import React, { useState } from 'react'

import './styles.scss'

const AnswerText = ({ answer, onSelectAnswer }) => {
	const [isSelected, setIsSelected] = useState(false)

	return (
		<div className={`answer-text__wrapper ${isSelected ? 'selected' : ''}`}>
			<div
				className="answer-text"
				onClick={() => {
					setIsSelected(true)
					onSelectAnswer()
				}}
			>
				<span className="answer-text__value">{answer}</span>
			</div>
		</div>
	)
}

export { AnswerText }
